import moment from 'locale/momentLocale'
import React from 'react'

interface Props {
  timestamp: string
}

const Hour = ({ timestamp }: Props) => <span>{moment(timestamp).format('HH:mm:ss')}</span>

export default Hour
